import type { RouteObject } from "react-router-dom";

import { BatchRunDetailScreen } from "./BatchRunDetailScreen";
import { PracticeDetailScreen } from "./PracticeDetailScreen";
import { PracticesLandingScreen } from "./PracticesLandingScreen";

// Discovered by `router.tsx`'s `import.meta.glob("./screens/*/routes.tsx")` and mounted under `RequireSession` →
// `RootLayout`, exactly like `screens/review/routes.tsx`. `AcceptInvitationScreen` is NOT here — it is anonymous
// (§4h) and is wired directly into `router.tsx`'s top-level `routes` array beside `/auth/login` and friends.
export const routes: RouteObject[] = [
  { path: "/practice", element: <PracticesLandingScreen /> },
  { path: "/practice/:practiceId", element: <PracticeDetailScreen /> },
  { path: "/practice/:practiceId/batch-runs/:batchRunId", element: <BatchRunDetailScreen /> },
];
